import { ROUTES } from '@/constants/routes'
import { COMPANY_EMAIL } from '@/constants/variables'

export const menuItems = (userId: string) => [
  {
    anchor: 'My account',
    sublinks: [
      {
        anchor: 'My Subscriptions',
        link: ROUTES.SUBSCRIPTIONS,
      },
    ],
  },
  {
    anchor: 'Support',
    sublinks: [
      {
        anchor: 'FAQ',
        href: ROUTES.FAQ,
      },
      {
        anchor: 'Cancel Subscription',
        link: ROUTES.SUBSCRIPTIONS_WITH_CANCELED,
      },
    ],
  },
  {
    anchor: 'Money-Back Policy',
    href: ROUTES.MONEY_BACK,
  },
  {
    anchor: 'Privacy Policy',
    href: ROUTES.PRIVACY_POLICY,
  },
  {
    anchor: 'Terms of Use',
    href: ROUTES.TERMS,
  },
  {
    anchor: 'Meals Recommendations',
    href: ROUTES.MEALS_RECOMMENDATIONS,
  },
  {
    anchor: 'Contact Us',
    href: `mailto:${COMPANY_EMAIL}?accountId=${userId}`,
  },
]
